import { render, staticRenderFns } from "./PackagingView.vue?vue&type=template&id=4a81b685&scoped=true&"
import script from "./PackagingView.vue?vue&type=script&lang=js&"
export * from "./PackagingView.vue?vue&type=script&lang=js&"
import style0 from "./PackagingView.vue?vue&type=style&index=0&id=4a81b685&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a81b685",
  null
  
)

export default component.exports